export enum AgentInventoryActionType {
  Load = "Load",
  Unload = "Unload"
}
